// import nextIcon from '../../../../assets/editors/navigation_bar_next.svg'
// import superNextIcon from '../../../../assets/editors/navigation_bar_supernext.svg'
// import backIcon from '../../../../assets/editors/navigation_bar_back.svg'
// import superBackIcon from '../../../../assets/editors/navigation_bar_superback.svg'

import {ReactComponent as DoublechevronRight} from '../../../../assets/pagination/max_right_pagination_arrow_icon.svg';
import {ReactComponent as DoublechevronLeft} from '../../../../assets/pagination/max_left_pagination_arrow_icon.svg';
import {ReactComponent as ChevronRight} from '../../../../assets/pagination/right_pagination_arrow_icon.svg';
import {ReactComponent as ChevronLeft} from '../../../../assets/pagination/left_pagination_arrow_icon.svg';


import './TopBar.scss'
import React, {ChangeEvent, forwardRef, ReactElement, Ref, useEffect, useImperativeHandle, useState} from 'react'
import {useTypedSelector} from "../../../../hooks/useTypeSelector";
import {useDispatch} from "react-redux";
import {FlyerFrameSettingDto, FlyerPageSpotDto, SelectPageForTabsDto} from "../../../../dtos";
import {setSelectedPageForTabs} from "../../../../store/actionCreators/pagesActionCreators";
import styles from './TopBar.module.scss';
import {SimpleConfirmPopup} from "../../../../com/simpleConfirmPopup/SimpleConfirmPopup";
import {
    dispatchEventDataType,
    EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER
} from "../../../../globals/EventDispatcher";
import validator from "validator";
import {getFlippingFlyer} from "../../../../store";
import {makeStyles} from "@mui/styles";
import {Button, Input, Typography} from "@mui/material";

const useStyles = makeStyles(() => ({
    topBar: {
        display: "flex",
        alignItems: "center",
        flexFlow: "row",
        width: "100%",
        backgroundColor: "white",
        height: "40px",
        minHeight: "40px",
        maxHeight: "40px",
    },
    leftPart: {
        height: "100%",
        display: "flex"
        // width: "33%"
    },
    middlePart: (props: any) =>  ({
        height: "100%",
        flex: "1 1 auto",
        display: "flex",
        flexFlow: "row",
        columnGap: "4px",
        alignItems: "center",
        justifyContent: props.screen === "promos" ? "center" : "flex-start"
    }),
    rightPart: {
        // width: "33%"
        height: "100%",
        display: "flex"
    },
    navigationBtn: {
        width: `32px`,
        height: `32px`,
        "&.MuiButton-root": {
            '&:hover': {
                backgroundColor: '#107EC61A',
            },
            "&:disabled": {
                opacity: "0.4"
            }
        }
    },
    counterBox: {
        display: "flex",
        flexFlow: "row",
        columnGap: "4px",
        alignItems: "center",
        "& > .MuiTypography-root": {
            fontWeight: "bold",
            fontSize: "14px",
            // lineHeight: "16px",
            alignItems: "center",
            textAlign: "center",
            color: "#0b1423",
        }
    },
    inputWrapper: {
        width: `64px`,
        height: "26px",
        border: "1px solid #000000",
        borderRadius: "5px",
        "& > .MuiInput-input": {
            fontWeight: "bold",
            fontSize: "14px",
            lineHeight: "16px",
            alignItems: "center",
            textAlign: "center",
            color: "#0b1423",
            padding: "4px",
        }
    }
}))

export interface ITopBarRef {
    showBack: () => void;
    showNext: () => void;
}

interface ITopBar {
    total: number;
    // index zero based
    onPageIndexChanges: (index: number) => void;
    pageIndex: number;

    leftChildren?: ReactElement
    rightChildren?: ReactElement
    isDragStart?: boolean;
    selectedFramesData?: FlyerPageSpotDto[];
    currentFramesState?: FlyerFrameSettingDto;
    defaultFramesState?: FlyerFrameSettingDto;
    screen?: string
}

export const TopBar = forwardRef((props: ITopBar, ref: Ref<ITopBarRef>) => {
    const dispatch = useDispatch();
    const properties = {
        screen: props.screen || "promos"
    }
    const classes = useStyles(properties);
    useImperativeHandle(ref, () => ({showBack, showNext}));
    const [isShowConfirmExitPopup, setShowConfirmExitPopup] = useState<boolean>(false);
    let selectedPageState = useTypedSelector<SelectPageForTabsDto>((state) => state.selectPageForTabs);
    let flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    let {spots} = useTypedSelector((state) => state);


    const [pageIndex, setPageIndex] = useState(props.pageIndex)
    const [tempPageIndex, setTempPageIndex] = useState(props.pageIndex)

    const onInputPageIndexChange = (e: ChangeEvent<HTMLInputElement>) => {
        const value = Number(e.target.value);
        if (value !== 0 && value <= props.total) {
            var currentValue = parseInt(e.target.value);
            checkerFrameStateBeforeChangeThePage(currentValue);
        }
    }

    useEffect(() => {
        setPageIndex(selectedPageState.pageNo === 0 ? 1 : selectedPageState.pageNo);
    }, [selectedPageState])

    const showBack = () => {
        if (pageIndex > 1) {
            // dispatch(setSelectedPageForTabs({
            //     pageNo: pageIndex - 1
            // }));
            checkerFrameStateBeforeChangeThePage(pageIndex - 1);
        }
    }

    const showNext = () => {
        if (pageIndex < props.total) {
            // dispatch(setSelectedPageForTabs({
            //     pageNo: pageIndex + 1
            // }));
            checkerFrameStateBeforeChangeThePage(pageIndex + 1);
        }
    }

    const changePageIndex = (index: number) => {
        if (index < 1) {
            index = 1
        } else if (index > props.total) {
            index = props.total
        }

        dispatch(setSelectedPageForTabs({
            pageNo: index
        }));

        // pass zero based index
        props.onPageIndexChanges(index - 1)
    }

    const checkerFrameStateBeforeChangeThePage = (index: number) => {
        const isCurrentFramesStateSettingHasChanges = compareDefaultAndCurrentState();
        if (isCurrentFramesStateSettingHasChanges) {
            setTempPageIndex(index)
            setShowConfirmExitPopup(true)
        } else {
            changePageIndex(index);
        }
    }

    const onSaveFramesSetting = () => {
        if (props?.selectedFramesData?.length) {
            dispatchEventDataType(EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER, {
                selectedFrames: props.selectedFramesData,
                newData: props.currentFramesState,
                isHorizontalOrientationForFrames: spots.isHorizontalOrientationForFrames
            });
        }
    }

    const compareDefaultAndCurrentState = (): boolean => {
        return JSON.stringify(props.defaultFramesState) !== JSON.stringify(props.currentFramesState);
    }

    const checkerBeforeSavePromoDetails = () => {
        let isValid: boolean;
        switch (props?.currentFramesState?.fpsFrameType) {
            case 2:
                const isLegalNumber = Number(props.currentFramesState.fpsFrameLink) >= 1 && Number(props.currentFramesState.fpsFrameLink) <= flyerDetailsState?.flyerPages?.length;
                isValid = validator.isNumeric(props.currentFramesState.fpsFrameLink ? props.currentFramesState.fpsFrameLink : ``) && isLegalNumber;
                break;
            case 3:
            case 4:
            case 5:
            case 6:
                isValid = validator.isURL(props.currentFramesState.fpsFrameLink ? props.currentFramesState.fpsFrameLink : ``);
                break;
            default:
                isValid = true;
                break;
        }
        if (!isValid) {

        } else {
            onSaveFramesSetting();
            changePageIndex(tempPageIndex);
            setTimeout(() => {
                dispatch(getFlippingFlyer(flyerDetailsState.flyRecId));
            }, 500)
        }
    }

    const onCloseWithoutSaving = () => {
        setShowConfirmExitPopup(false);
        changePageIndex(tempPageIndex);
    };


    return (
        <div className={classes.topBar}>
            {/*<div className="flyer_spots_editor_navigation_bar">*/}

            <div className={classes.leftPart}>
                {props.leftChildren}
            </div>

            <div className={classes.middlePart}>
                {
                    props.total > 1 &&
                    <>
                        <Button
                            className={classes.navigationBtn}
                            disabled={pageIndex === 1}
                            onClick={() => checkerFrameStateBeforeChangeThePage(1)}>
                            <DoublechevronLeft/>
                        </Button>
                        <Button
                            className={classes.navigationBtn}
                            disabled={pageIndex === 1}
                            onClick={() => showBack()}>
                            <ChevronLeft/>
                        </Button>
                    </>
                }

                <div className={classes.counterBox}>
                    {props.total === 1 ?
                        <Typography>
                            {selectedPageState.pageNo === 0 ? 1 : selectedPageState.pageNo}
                        </Typography> :
                        <Input
                            className={classes.inputWrapper}
                            inputProps={{
                                "type": "text",
                                "pattern": "[0-9]+",
                                "aria-valuemin": 1
                            }}
                            type="text"
                            value={selectedPageState.pageNo === 0 ? 1 : selectedPageState.pageNo}
                            onChange={onInputPageIndexChange}
                            disableUnderline
                        />

                    }
                    <Typography>{`/ ${props.total}`}</Typography>
                </div>
                {
                    props.total > 1 && <>
                        <Button
                            className={classes.navigationBtn}
                            disabled={pageIndex === props.total}
                            onClick={() => showNext()}>
                            <ChevronRight/>
                        </Button>
                        <Button
                            className={classes.navigationBtn}
                            disabled={pageIndex === props.total}
                            onClick={() => checkerFrameStateBeforeChangeThePage(props.total)}>
                            <DoublechevronRight/>
                        </Button>
                    </>
                }
            </div>

            <div className={classes.rightPart}>
                {props.rightChildren}
            </div>
            {props?.isDragStart && <div className={styles.drag_start}>

            </div>}

            {isShowConfirmExitPopup && (
                <SimpleConfirmPopup
                    onClose={setShowConfirmExitPopup}
                    contentText={`Save changes?`}
                    onConfirm={checkerBeforeSavePromoDetails}
                    buttonText={[`Save`, `Don't Save`, `Cancel`]}
                    onCloseWithoutSaving={onCloseWithoutSaving}
                />
            )}


        </div>
    )
})